import { useSearchParamState } from './useSearchParamState';
import { ChangeEvent } from 'react';

interface RegisterOption {
  onChange?: (event: ChangeEvent<{ value: string }>) => void;
}

export function useFilterForm<TResult extends Record<string, unknown>>(parser: (data: unknown) => TResult) {
  const { values, setValue: setSearchParamValue } = useSearchParamState<TResult>(parser);

  function register(key: keyof TResult, options?: RegisterOption) {
    return {
      onChange: (event: ChangeEvent<{ value: string }>) => {
        setValue(key, event.target.value);

        const keys = Object.keys(values) as (keyof TResult)[];

        if (keys.includes('pageIndex') && key !== 'pageIndex') {
          setValue('pageIndex' as keyof TResult, '1');
        }

        if (options?.onChange) {
          options.onChange(event);
        }
      },
      defaultValue: values[key],
    };
  }

  function setValue(key: keyof TResult, value: string | undefined) {
    setSearchParamValue(key, value);

    const keys = Object.keys(values) as (keyof TResult)[];

    if (keys.includes('pageIndex') && key !== 'pageIndex') {
      setValue('pageIndex' as keyof TResult, '1');
    }
  }

  return {
    register,
    setValue,
    values,
  };
}
